import {MOON_250} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DrawerContents = styled.div`
  padding: 60px 20px 0px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
DrawerContents.displayName = 'S.DrawerContents';

export const DrawerMain = styled.div`
  flex: 1 1 auto;
`;
DrawerMain.displayName = 'S.LinksDrawerMain';

export const Header = styled.div`
  font-family: Source Sans Pro;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
`;
Header.displayName = 'S.Header';

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
`;
HeaderRow.displayName = 'S.HeaderRow';

export const RightButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
  float: right;
`;
RightButton.displayName = 'S.RightButton';

export const UnderLine = styled.div`
  height: 1px;
  background: ${MOON_250};
  padding: 0;
  width: 100%;
  position: absolute;
  margin-left: -20px;
  margin-top: 16px;
`;
UnderLine.displayName = 'S.UnderLine';

export const RunName = styled.h4`
  line-height: 80px;
  font-weight: bold;
  margin: 0 10px 0 0;
`;
RunName.displayName = 'S.RunName';

export const SectionTitle = styled.h5`
  font-weight: 600;
  margin-bottom: 6px;
  margin-top: 20px;
`;
RunName.displayName = 'S.SectionTitle';

export const SectionText = styled.p`
  display: inline-block;
  margin-bottom: 0;
  margin-top: 0;
  vertical-align: top;
`;
SectionText.displayName = `S.SectionText`;
